import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider as CognitoAuthProvider } from 'react-oidc-context';
import { AuthProvider } from './context/AuthContext';
import './index.css';
import './styles/variables.css';
import './styles/components.css';

const cognitoAuthConfig = {
  authority: (import.meta.env.VITE_COGNITO_AUTHORITY || "https://cognito-idp.af-south-1.amazonaws.com/af-south-1_pAm2YdkAo").trim(),
  client_id: (import.meta.env.VITE_COGNITO_CLIENT_ID || "3k92blknfqp1vtqd7bk9k95u7j").trim(),
  redirect_uri: (import.meta.env.VITE_COGNITO_REDIRECT_URI || "https://lms.jalusitech.co.za/auth/login").trim(),
  post_logout_redirect_uri: (import.meta.env.VITE_COGNITO_LOGOUT_URI || "https://lms.jalusitech.co.za/auth/login").trim(),
  response_type: "code",
  scope: "phone openid email",
};

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <CognitoAuthProvider {...cognitoAuthConfig}>
            <BrowserRouter>
                <AuthProvider>
                    <App />
                </AuthProvider>
            </BrowserRouter>
        </CognitoAuthProvider>
    </React.StrictMode>
);

